// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3FqtB","actionsCol":"EnrolledClinics_actionsCol__6hcvs"};